import React from 'react';
import get_bundle from '../domain/get_bundle';
import Locale from '../domain/Locale';
import getMadaiURL from '../domain/getMadaiURL';
import { props } from 'tcomb-react';

@props({
  locale: Locale
})
export default class Conditions extends React.Component {
  render() {
    const locale = this.props.locale;
    function getHref() {
      if (locale.toJSON() === 'it_IT') {
        return 'https://it.madai.com/terms.html';
      } else {
        return "https://madai.com/terms.html"
      }
      /*
      const _locale = locale.toString();
      const country = locale.country.toLowerCase();
      if (_locale === 'en_ZA') {
        return 'http://za.shop.madai.com/FAQ_en.html';
      } else if (_locale === 'en_US') {
        return 'http://us.shop.madai.com/FAQ_en.html';
      } else if (_locale === 'it_IT') {
        return 'http://it.madai.com/FAQ_it.html';
      }
      else {
        return getMadaiURL() + country + '/terms-of-use.html';
      }*/
    }
    return <a target='_blank' href={getHref()}>{get_bundle(this.props.locale).footer.conditions}</a>;
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Conditions.js
 **/